import React from "react";

// Light HTML sanitization on the client — server jbuilder also limits
// to a safe tag set, but defense in depth.
const SAFE_TAGS = /<\/?(p|br|strong|em|i|b|mark|span)[^>]*>/gi;

const sanitize = (html) => {
  if (!html) return "";
  return String(html)
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/on\w+="[^"]*"/gi, "");
};

const ProofText = ({ proof, className = "", style, as: Tag = "div" }) => {
  const html = sanitize(proof.body || "");
  return (
    <Tag
      className={`prose-sm max-w-none ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default ProofText;
